import { render } from "./purchasesTables.vue?vue&type=template&id=5727b386&scoped=true"
import script from "./purchasesTables.vue?vue&type=script&lang=js"
export * from "./purchasesTables.vue?vue&type=script&lang=js"

import "./purchasesTables.vue?vue&type=style&index=0&id=5727b386&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5727b386"]])

export default __exports__